import { render, staticRenderFns } from "./notice_ul.vue?vue&type=template&id=1583b42c&scoped=true&"
import script from "./notice_ul.vue?vue&type=script&lang=js&"
export * from "./notice_ul.vue?vue&type=script&lang=js&"
import style0 from "./notice_ul.vue?vue&type=style&index=0&id=1583b42c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1583b42c",
  null
  
)

export default component.exports